import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  roles, // 👈 roles allowed for this route
  ...rest
}) => (
  
  <Route
    {...rest}
    
    render={props => {
      const authUser = localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser"))
        : null;
      // If route is protected and no user, redirect to login
      if (isAuthProtected && !authUser) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      // If roles are defined and user role is not allowed, redirect to dashboard
      if (roles && authUser && !roles.includes(authUser.user.Designation)) {

        return <Redirect to={authUser.user.Designation === "Administrate" ? "/dashboard" : authUser.user.Designation === "sales" ? "/dashboard" :"/user/dashboard"} />;
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}

  />
);

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  roles: PropTypes.array,
};

export default Authmiddleware;
